import { sendGTMEvent } from '@next/third-parties/google';

type EventPayload = { [key: string]: unknown };

/**
 * !!! The sendGoogleTagEvent function will handle all the logic for sending Google Tag Manager events !!!
 * @description Wrapper function for sending Google Tag Manager events
 * @param eventName - The name of the event to send
 * @param type - The type of event (e.g., 'Pageview', 'Click', etc.)
 * @param payload - Optional additional data to include with the event.
 */
export default function sendGoogleTagEvent(
  eventName: string,
  type: string,
  payload?: EventPayload,
) {
  const eventParams: EventPayload = {
    type: `${type}`,
    platform: 'react',
    ...payload,
  };

  sendGTMEvent({
    event: 'ga4_event',
    ga4_event_name: eventName,
    ga4_parameters: eventParams,
  });
}
